import React, { PureComponent, ReactElement } from 'react';

import { Link } from '@philips-emr/tws-components';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { arrayOf, eventListener, shape, string } from '@philips-emr/tws-core/lib/component/prop-types';
import { isFunction } from '@philips-emr/tws-utils';

import './attachments-list.css';
import AttachmentsListAPI, { AttachmentsListItem } from '../../api/attachments-list-api';

export interface AttachmentsListProps {
  data?: AttachmentsListItem[];
  onSelect: (event: {}) => void;
}

@AwesomeComponent({ api: AttachmentsListAPI, type: ComponentType.DATA_DISPLAY })
class AttachmentsList extends PureComponent<AttachmentsListProps> {

  static propTypes = {
    data: arrayOf(shape({ label: string, value: string })),
    onSelect: eventListener,
  };

  onSelect = (item: AttachmentsListItem): void => {
    const { onSelect } = this.props;

    if (isFunction(onSelect)) {
      onSelect({ value: item });
    }
  };

  renderContent(): ReactElement[] | null {
    const { data } = this.props;
    if (!Array.isArray(data)) {
      return null;
    }

    return data.map((item, index) => {
      return (
        <div key={`${index}`} className="c-attachments-list__item">
          <Link onClick={() => this.onSelect(item)} value={item.label} icon={<div className="c-attachments-list__icon" />} />
        </div>
      );
    });
  }

  render(): ReactElement {
    return (
      <div className="c-attachments-list__wrapper">
        {this.renderContent()}
      </div>
    );
  }

}

export default AttachmentsList;
